import { normalizeURL } from '@philips-internal/oswald-common-utils';
import { isContentfulString, recursiveFreeze } from '@philips-internal/oswald-ui-utils';
function createConfigurationService() {
    let authenticationConfiguration = null;
    let base = '';
    let endpointMappers = null;
    const getBaseURL = () => {
        return base;
    };
    const initialize = async () => {
        // @ts-expect-error
        const { get } = await import('virtual:oswald-configuration');
        const runtime = await get();
        base = runtime.application?.base ?? '';
        if (isContentfulString(base)) {
            base = normalizeURL(base);
        }
    };
    const getAuthenticationConfiguration = () => {
        return authenticationConfiguration;
    };
    const setAuthenticationConfiguration = (configuration) => {
        if (authenticationConfiguration) {
            throw new Error('[Configuration Service]: The authentication configuration was already set.');
        }
        authenticationConfiguration = recursiveFreeze(configuration);
    };
    const getEndpointMappers = () => {
        return endpointMappers;
    };
    const setEndpointMappers = (mapper) => {
        if (endpointMappers) {
            throw new Error('[Configuration Service]: The endpoint mappers was already set.');
        }
        endpointMappers = mapper;
    };
    return {
        getAuthenticationConfiguration,
        getBaseURL,
        getEndpointMappers,
        initialize,
        setAuthenticationConfiguration,
        setEndpointMappers,
    };
}
const ConfigurationService = createConfigurationService();
export { ConfigurationService, };
//# sourceMappingURL=configuration-service.js.map